import React, { Component } from 'react';
import { Nav, NavItem, NavLink, Collapse, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import '../_Content/css/sidebar.css';
import { PropTypes } from 'prop-types';
import Menu from './Menu';
import Config from '../Util/config';
import HttpUtil from '../Util/httpUtil';
import '../_Content/css/titulo.css';

const administrador = localStorage.getItem("Administrador") === 'true';
const vendas = localStorage.getItem("usuarioVendas") === 'true';
const isSimulacao = localStorage.getItem("isSimulacao") === 'true';
const nomeUsuario = localStorage.getItem("NomeUsuario");
const codUsuarioOld = localStorage.getItem("CodUsuario_OLD");

class Sidebar extends Component {

	constructor(props) {
		super(props);
		this.ajuda = React.createRef();
		this.state = {
			setarMenu: (window.location.pathname.split("/")[1] == '') ? '/' : window.location.pathname.split("/")[1],
			ambiente: window.location.href.indexOf("ec2-34-206-89-100.compute-1.amazonaws.com:9090"),
			administrativoIsOpen: true
		};

		this.menu = new Menu();
		this.menuItens = this.menu.Itens;
		this.menuItensAdministrativos = this.menu.ItensAdministrativos;
	};

	setMenu = (event) => {
		this.setState({ setarMenu: event.target.title });
	};

	toggle = () => {
		this.setState({
			administrativoIsOpen: !this.state.administrativoIsOpen
		});
	}

	sairSimulacao = () => {
        var url = `${Config.urls.API_URL_BASE}Acesso/ValidarDadosLogin/${codUsuarioOld}`;

        return new Promise((resolve, reject) => {
            HttpUtil.eco_GET(url, (response) => {
                if (response.data == null || response.data == "") {
                    window.location = "/erro";
                } else {
                    localStorage.setItem("CodUsuario_OLD", "");
                    localStorage.setItem("CodUsuario", response.data.CodUsuario);
                    localStorage.setItem("NomeUsuario", response.data.NomeUsuario);
                    localStorage.setItem("Login", response.data.Login);
                    localStorage.setItem("Email", response.data.Email);
                    localStorage.setItem("NomePerfil", response.data.NomePerfil);
                    localStorage.setItem("Administrador", response.data.Administrador);
                    localStorage.setItem("isSimulacao", false);
                    localStorage.setItem("TermoUso", response.data.TermoUso);
                    localStorage.setItem("roles", JSON.stringify(response.data.Roles));
                    localStorage.setItem("Hash", response.data.Hash);
                    localStorage.setItem("isContribuicaoPiloto", response.data.isContribuicaoPiloto);
                    localStorage.setItem("ExibirNotificacaoArquivosRecentes", response.data.ExibirNotificacaoArquivosRecentes);
                    localStorage.setItem("isPro", response.data.isPro);
					localStorage.setItem("Token", "");

                    window.location = "/simular-acesso";
                }
            }, () => { window.location = "/erro"; });
        });
	};

	showSubItem = (item) => {

		let urlSubItem = (window.location.pathname.split("/")[1] == '') ? '/' : window.location.pathname.split("/")[1];

		if ((item.title === 'arquivos-recentes') && (urlSubItem === 'resultadoErros' || urlSubItem === 'resultado')) {
			return (
				<div>
					<NavLink tag={Link}
							to={item.path}
							title={item.nome}
							onClick={this.setMenu}>

							<i className={item.ico}></i>
							{item.nome}
					</NavLink>
					{this.props.origem === 'arquivos' &&
						<NavLink className='active subitem' title={urlSubItem === 'resultadoErros' ? "Resultado de Erros" : "Resultados" }>
							<i className='ecoico ecoico-lista'></i>
							{urlSubItem === 'resultadoErros' ? "Resultado de Erros" : "Resultados"}
						</NavLink>
					}
				</div>
			)
		}
		else if ((item.title === 'historicoResultado') && (urlSubItem === 'resultadoErros' || urlSubItem === 'resultado')) {
			return (
				<div>
					<NavLink tag={Link}
							 to={item.path}
							 title={item.nome}
							 onClick={this.setMenu}>

							<i className={item.ico}></i>
							{item.nome}
					</NavLink>
					{this.props.origem === 'historico' &&
						<NavLink className='active subitem' title={urlSubItem === 'resultadoErros' ? "Resultado de Erros" : "Resultados" }>
							<i className='ecoico ecoico-lista'></i>
							{urlSubItem === 'resultadoErros' ? "Resultado de Erros" : "Resultados"}
						</NavLink>
					}
				</div>
			)
		}
		else {
			return (
				<NavLink tag={Link}
						 to={item.path}
						 title={item.nome}
						 onClick={this.setMenu}
						 className={(urlSubItem === item.title) ? 'active' : ''}>

						<i className={item.ico}></i>
						{item.nome}
				</NavLink>
			)
		}

		{/* <NavLink tag={Link}
		to={item.path}
		title={item.title}
		onClick={this.setMenu}
		className={(this.state.setarMenu === item.title) ? 'active' : ''}>
		<i className={item.ico}></i>
		{item.nome}
		</NavLink> */}

	}

	getCurrentDate = () => {
        const date = new Date();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
		const baseURL = '/manual-ecoauditor.pdf?time=';
        return `${baseURL}${hours}:${minutes}:${seconds}`;
    };

    ambienteManual = () => {
        return(
            <a href={this.getCurrentDate()}
                target="_blank" download className="nav-link">
                <i className="ecoico ecoico-manual ecosuportico"></i>
                <span>Manual do Usuário</span>
            </a>
        )
    }

	ambienteJornada = () => {
        return(
            <a href="https://perfil.econeteditora.com.br/jornada-econet/9"
                target="_blank" download className="nav-link">
                <i className="ecoico ecoico-jornada ecosuportico"></i>
                <span>Vídeo Explicativo</span>
            </a>
        )
    }

	ambienteSuporte = () => {
		if(this.state.ambiente > 0){
			return(
				<a target="_blank" className="nav-link" onClick={this.props.actionModalAjuda}>
					<i className="ecoico ecoico-support ecosuportico"></i>
					<span>Suporte Técnico</span>
				</a>
			)
		}
		else{
			return(
				<a href="https://www.econeteditora.com.br/solucoes/index.php?acao=envio&form[destino]=10&form[area]=34&form[tipo]=6&form[assunto]=413"
					target="_blank" className="nav-link">
						<i className="ecoico ecoico-support ecosuportico"></i>
						<span>Suporte Técnico</span>
				</a>
			)
		}
	}

	render() {
		Nav.propTypes = {
			tabs: PropTypes.bool,
			pills: PropTypes.bool,
			card: PropTypes.bool,
			justified: PropTypes.bool,
			fill: PropTypes.bool,
			vertical: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
			horizontal: PropTypes.string,
			navbar: PropTypes.bool,
			tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
		};

		NavLink.propTypes = {
			disabled: PropTypes.bool,
			active: PropTypes.bool,
			tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
			innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
		};

		return (
			<aside className="aside">
				<div className="ecoheader">
					<div className="row">
						<a className="col-6 align-self-center">
							<img src="/img/logo-econet.svg" alt="Econet Editora" />
						</a>
						{/*
						<a className="col text-center">
							<img src="/img/logo-proj.svg" alt="Logo Projeto"/>
						</a>
						*/}
						<div className="flex-row-reverse menu-collapse">
							<a className="menu float-right" onClick={this.props.action}>
								<i className="fas fa-sign-in-alt"></i>
							</a>
						</div>
					</div>
					<div className="row">
						<div className='titulo-sistema'>
							EcoAuditor
						</div>
					</div>
				</div>

				{isSimulacao &&
					<div className="menu-simulacao ">
						<Row>
							<Col xs={2}>
								<div className="logo">
									<span>S</span>
								</div>
							</Col>
							<Col xs={10}>
								<label>{nomeUsuario}</label>

								<div className="sair-simulacao">
									<span>Simulando acesso</span>
									<i class="fas fa-sign-out-alt ecoico" onClick={() => this.sairSimulacao()}></i>
								</div>
							</Col>
						</Row>
					</div>
				}

				<Nav vertical={true}>
					{this.menuItens.map((item) => {
							return (
								<NavItem>
									{(item.title === 'enviar-arquivos') ?
										(
											<NavLink title={item.nome}
													 onClick={this.props.actionModalUpload}
													 className={(this.state.setarMenu === item.title) ? 'active' : ''}>
												<i className={item.ico}></i>
												{item.nome}
											</NavLink>
										)
										: (
											this.showSubItem(item)
										)
									}
								</NavItem>
							)
						})
					}
				</Nav>

				{(administrador || vendas) &&
					<div className="servicos-administrativos">
						<Nav vertical={true}>
							{/* <NavItem className="collapse-menu">
								<NavLink onClick={this.toggle}>
									<i className={`caret fas fa-fw ${this.state.administrativoIsOpen ? 'fa-caret-down' : 'fa-caret-right'}`}></i>
									Serviços Administrativos
								</NavLink>
							</NavItem> */}
							<Collapse isOpen={this.state.administrativoIsOpen} navbar>
								{
									this.menuItensAdministrativos.map((item) => {
										return (
											<NavItem>
												<NavLink tag={Link}
													to={item.path}
													title={item.nome}
													onClick={this.setMenu}
													className={(this.state.setarMenu === item.title) ? 'active' : ''}>

													<i className={item.ico}></i>
													{item.nome}
												</NavLink>
											</NavItem>
										)
									})
								}
							</Collapse>
						</Nav>
					</div>
				}

				<div className="ecofooter">
					<ul className="nav flex-column">
                        <li className="nav-item">
                            {this.ambienteManual()}
                        </li>
                        <li className="nav-item">
                            {this.ambienteJornada()}
                        </li>
                        <li className="nav-item">
							{this.ambienteSuporte()}
						</li>
						<li className="nav-item">
							<a onClick={this.props.actionModalFeedback} className="nav-link">
								<i className="ecoico ecoico-feedback"></i>
								<span>Deixe-nos sua opinião</span>
							</a>
						</li>
					</ul>
				</div>
			</aside>
		)
	}
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/Layout/Sidebar.jsx